<template>
  <section class="stepper-section"
           :class="classes">
    <div class="stepper-section-title-wrapper" v-if="label">
      <h4 class="stepper-section-title">
        {{label}}
      </h4>
      <i v-if="help" class="mdi mdi-help-circle-outline pointer" v-tooltip.html="help" @click="$emit('on-help-click')"></i>
    </div>       

    <div class="stepper-section-body">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: false,
    },
    halfWidth: {
      type: Boolean,
    },
    help: {
      type: String,
      required: false
    }
  },

  computed: {
    classes() {
      return {
        "full-width": !this.halfWidth,
        "half-width": this.halfWidth,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.stepper-section {
  text-align: center;
  padding-bottom: 30px;

  .stepper-section-title-wrapper {
    display: flex;
    gap: 6px;
    align-items: center;
    color: #707070;   

    .mdi {
      margin-bottom: 14px
    }
  }

  &[inline] {
    .stepper-section-body {
      display: flex;
    }

    &[center] {
      .stepper-section-body {
        justify-content: center;
      }
    }
  }
}
</style>
